import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

import { RootState } from "../../redux/store";
import { Currency } from "./types/locale-types";

type CurrencySliceState = {
  items: Currency[];
  loading: boolean;
  error: string | null;
};

const initialState: CurrencySliceState = {
  items: [],
  loading: false,
  error: null,
};

const API_URL = process.env.REACT_APP_API_URL;

export const fetchAllCurrencies = createAsyncThunk<
  Currency[],
  void,
  { rejectValue: string; state: RootState }
>("currency/fetchAll", async (_, thunkAPI) => {
  const token = thunkAPI.getState().auth.token;

  try {
    const headers: Record<string, string> = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const res = await axios.get(`${API_URL}/currencies`, {
      params: { page: 1, per_page: 1000 },
      headers,
    });

    const payload = res.data;
    const data = payload?.data?.data ?? payload?.data ?? payload;
    return Array.isArray(data) ? data : [];
  } catch (err: any) {
    return thunkAPI.rejectWithValue(
      err.response?.data?.message || "Failed to fetch currencies"
    );
  }
});

const currencySlice = createSlice({
  name: "currency",
  initialState,
  reducers: {
    clearCurrencyError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllCurrencies.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllCurrencies.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchAllCurrencies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch currencies";
      });
  },
});

export const { clearCurrencyError } = currencySlice.actions;
export default currencySlice.reducer;
